import React from 'react'

export interface QRIconProps {
  width?: number
  height?: number
  fill?: string
  className?: string
}

const QRIcon: React.FC<QRIconProps> = ({
  width = 15,
  height = 15,
  fill = '#000626',
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0.700195 6.70001H2.2002V8.20001H0.700195V6.70001ZM6.7002 2.20001H8.2002V5.20001H6.7002V2.20001ZM5.2002 6.70001H8.2002V9.70001H6.7002V8.20001H5.2002V6.70001ZM9.7002 6.70001H11.2002V8.20001H12.7002V6.70001H14.2002V8.20001H12.7002V9.70001H14.2002V12.7H12.7002V14.2H11.2002V12.7H8.2002V14.2H6.7002V11.2H9.7002V9.70001H11.2002V8.20001H9.7002V6.70001ZM12.7002 12.7V9.70001H11.2002V12.7H12.7002ZM9.7002 0.700012H14.2002V5.20001H9.7002V0.700012ZM11.2002 2.20001V3.70001H12.7002V2.20001H11.2002ZM0.700195 0.700012H5.2002V5.20001H0.700195V0.700012ZM2.2002 2.20001V3.70001H3.7002V2.20001H2.2002ZM0.700195 9.70001H5.2002V14.2H0.700195V9.70001ZM2.2002 11.2V12.7H3.7002V11.2H2.2002Z"
        fill={fill}
      />
    </svg>
  )
}

export default QRIcon
